<div class="model-box" [class.is-disabled]="isDisable" [class.is-selected]="selected" (click)="onClick(model)">
    <div class="selected-icon" [class.is-selected]="selected">
        <svg-icon fontSize="35px" key="check"></svg-icon>
    </div>
    <div class="model-logo">
        <svg-icon fontSize="100px" [key]="icon"></svg-icon>
    </div>
    <div class="model-detail">{{model.description}}</div>
</div>
